import _ from 'lodash'
import type {SingleComponentPluginFunction} from '../../types'
import {isInnerElementsMapWrapper, INNER_ELEMENTS_MAP_TYPE_POSTFIX} from './common'

const wrapInnerElements = (obj: any, componentOrElementType: string): void => {
    _.forOwn(obj, (val: any, key: string) => {
        if (_.isArray(val)) {
            for (const item of val) {
                if (_.isPlainObject(item)) {
                    wrapInnerElements(item, item?.referredType ?? componentOrElementType)
                }
            }
            return
        }

        if (!_.isPlainObject(val)) return

        if (isInnerElementsMapWrapper(val)) {
            wrapInnerElements(val.innerElements, val?.referredType ?? componentOrElementType)
            return
        }

        // Field name indicates an inner elements map -
        // wrap if not wrapped yet
        if (key.toLowerCase().includes('innerelements')) {
            obj[key] = {
                type: `${componentOrElementType}.${INNER_ELEMENTS_MAP_TYPE_POSTFIX}`,
                innerElements: val
            }
            wrapInnerElements(obj[key].innerElements, val?.referredType ?? componentOrElementType)
            return
        }

        wrapInnerElements(val, val?.referredType ?? componentOrElementType)
    })
}

export const unpack: SingleComponentPluginFunction = (component): void => {
    const {componentType} = component
    wrapInnerElements(component, componentType)
}
